import MoaPanel from "./moa_panel";
import { MoaFormAnatomy, MOA_FORM_BASE_HTML_CLASS, renderStatusHint } from "../helpers/moa_panel_hints";

// AccountForm — email entry to sign in to an existing Rankers account (the optional
// "verify-to-legitimise" flow; it never gates the accept). Submit → host.beginSignIn
// (request an emailed code); Back → host.closeSignIn (return to the accept panel).
export const AccountFormConfig = {
  componentTypeKey: "MoaAccountForm",
  baseHtmlClass: MOA_FORM_BASE_HTML_CLASS,
  selector: ".member_offer_acceptor__form--account",
  phase: "account",

  emailInputSelector: ".member_offer_acceptor__form__field--email input",
  hintSelector: MoaFormAnatomy.hintSelector,
  backButtonSelector: MoaFormAnatomy.backButtonSelector,
};

export class AccountForm extends MoaPanel {
  static get config() { return AccountFormConfig; }

  constructor(id_or_element, host) {
    super(id_or_element, host, AccountFormConfig);

    this.emailInput = this.element.querySelector(AccountFormConfig.emailInputSelector);
    this.hintEl = this.element.querySelector(AccountFormConfig.hintSelector);
    this.backButton = this.element.querySelector(AccountFormConfig.backButtonSelector);
    this.defaultHint = this.hintEl.textContent;

    this.element.addEventListener("submit", this.handleSubmit.bind(this));
    this.backButton.addEventListener("click", this.handleBack.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.host.beginSignIn(this.emailInput.value);
  }

  handleBack(event) {
    event.preventDefault();
    this.host.closeSignIn();
  }

  render() {
    this.renderPanelVisibility();

    this.emailInput.disabled = !!this.readStateMachineValue("authBusy");

    // Prefill from the address in play (authEmail — seeded from the accept form's email
    // when the user opened sign-in) without clobbering what they're actively typing.
    if (document.activeElement !== this.emailInput) {
      this.emailInput.value = this.readStateMachineValue("authEmail") || "";
    }

    renderStatusHint(this.hintEl, this.readStateMachineValue("authStatus"), this.defaultHint);
  }
}
